export const makeChoiceQuestions = [
  {
    questionNumber: 1,
    questionText: "Would you prefer coffee or tea?",
    choices: {
      A: "I'll have a cup of coffee, please.",
      B: "The meeting starts in 10 minutes.",
      C: "I already had lunch.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "커피와 차 중에서 어떤 것을 선호하시나요?",
      choices: {
        A: "커피 한 잔 주세요.",
        B: "회의가 10분 후에 시작합니다.",
        C: "저는 이미 점심을 먹었습니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. A는 커피를 선택하는 적절한 답변입니다. B는 회의 시작 시간에 대한 정보이고, C는 점심 식사 여부에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 2,
    questionText: "Do you want to have the meeting in person or online?",
    choices: {
      A: "Either works for me.",
      B: "The meeting room is on the second floor.",
      C: "The financial report is due tomorrow.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의를 대면으로 할까요, 온라인으로 할까요?",
      choices: {
        A: "둘 다 괜찮습니다.",
        B: "회의실은 2층에 있습니다.",
        C: "재무 보고서 마감이 내일입니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. A는 두 가지 옵션 모두 가능하다는 적절한 답변입니다. B는 회의실 위치에 대한 정보이고, C는 보고서 마감에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 3,
    questionText: "Do you want a salad or soup with your meal?",
    choices: {
      A: "The restaurant has vegetarian options.",
      B: "Actually, I'd prefer just the main dish.",
      C: "The parking lot is behind the building.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "식사와 함께 샐러드나 수프 중 어떤 것을 원하시나요?",
      choices: {
        A: "레스토랑에 채식 옵션이 있습니다.",
        B: "사실 메인 요리만 먹고 싶습니다.",
        C: "주차장은 건물 뒤에 있습니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. B는 제시된 선택지 대신 다른 선택을 제안하는 적절한 답변입니다. A는 레스토랑 메뉴에 대한 정보이고, C는 주차장 위치에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 4,
    questionText: "Do you want me to call or email the client?",
    choices: {
      A: "The client requested a meeting next week.",
      B: "Actually, I'd prefer a face-to-face meeting.",
      C: "The conference room has a projector.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "고객에게 전화를 할까요, 이메일을 보낼까요?",
      choices: {
        A: "고객이 다음 주에 미팅을 요청했습니다.",
        B: "사실 직접 만나서 이야기하는 게 좋겠습니다.",
        C: "회의실에 프로젝터가 있습니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. B는 제시된 선택지 대신 직접 만남을 제안하는 적절한 답변입니다. A는 고객의 미팅 요청에 대한 정보이고, C는 회의실 시설에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 5,
    questionText: "Do you want to pay in installments or all at once?",
    choices: {
      A: "The store accepts credit cards.",
      B: "The item is available in two colors.",
      C: "I need to check my budget first.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "할부로 결제하시겠습니까, 아니면 일시불로 하시겠습니까?",
      choices: {
        A: "이 매장은 신용카드를 받습니다.",
        B: "상품은 두 가지 색상이 있습니다.",
        C: "예산을 먼저 확인해봐야 할 것 같습니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. C는 결정을 보류하는 적절한 답변입니다. A는 결제 수단에 대한 정보이고, B는 상품 색상에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 6,
    questionText: "Do you want us to contact you by phone or email?",
    choices: {
      A: "Either method works fine for me.",
      B: "The customer support team is available 24/7.",
      C: "The order was shipped yesterday.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "전화로 연락드릴까요, 이메일로 연락드릴까요?",
      choices: {
        A: "어느 쪽이든 괜찮습니다.",
        B: "고객 지원팀이 24시간 운영됩니다.",
        C: "주문하신 물건은 어제 발송되었습니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. A는 두 가지 연락 방법 모두 가능하다는 적절한 답변입니다. B는 고객 지원팀 운영 시간에 대한 정보이고, C는 주문 배송에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 7,
    questionText: "Do you want standard shipping or express delivery?",
    choices: {
      A: "The delivery trucks arrive in the morning.",
      B: "The store has extended its opening hours.",
      C: "I'd rather pick it up in-store.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question:
        "일반 배송으로 하시겠습니까, 아니면 특급 배송으로 하시겠습니까?",
      choices: {
        A: "배송 트럭은 아침에 도착합니다.",
        B: "매장이 영업 시간을 연장했습니다.",
        C: "직접 매장에서 수령하고 싶습니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. C는 제시된 배송 방법 대신 매장 수령을 제안하는 적절한 답변입니다. A는 배송 트럭 도착 시간에 대한 정보이고, B는 매장 영업 시간에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 8,
    questionText: "Would you prefer to meet in the office or online?",
    choices: {
      A: "The office has a large meeting room.",
      B: "Online would be more convenient.",
      C: "The agenda was sent this morning.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "사무실에서 만날까요, 아니면 온라인으로 할까요?",
      choices: {
        A: "사무실에 큰 회의실이 있습니다.",
        B: "온라인이 더 편할 것 같습니다.",
        C: "회의 안건이 오늘 아침에 발송되었습니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. B는 온라인 미팅을 선택하는 적절한 답변입니다. A는 회의실 크기에 대한 정보이고, C는 회의 안건 발송에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 9,
    questionText: "Would you prefer a window seat or an aisle seat?",
    choices: {
      A: "The plane arrives at 7 p.m.",
      B: "The check-in counter is near the entrance.",
      C: "Either one is fine with me.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "창가 좌석과 통로 좌석 중 어느 쪽을 선호하시나요?",
      choices: {
        A: "비행기가 오후 7시에 도착합니다.",
        B: "체크인 카운터가 입구 근처에 있습니다.",
        C: "어느 쪽이든 괜찮습니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. C는 두 좌석 모두 괜찮다는 적절한 답변입니다. A는 비행기 도착 시간에 대한 정보이고, B는 체크인 카운터 위치에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 10,
    questionText: "Would you prefer to stay at a hotel or a rental apartment?",
    choices: {
      A: "I need to check the prices first.",
      B: "The hotel has a rooftop pool.",
      C: "The tour guide speaks three languages.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question:
        "호텔에 머무르시겠습니까, 아니면 렌탈 아파트를 이용하시겠습니까?",
      choices: {
        A: "먼저 가격을 확인해봐야 할 것 같습니다.",
        B: "호텔에 루프탑 수영장이 있습니다.",
        C: "관광 가이드가 세 가지 언어를 구사합니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. A는 가격 확인이 필요하다며 결정을 보류하는 적절한 답변입니다. B는 호텔 시설에 대한 정보이고, C는 가이드의 언어 능력에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 11,
    questionText: "Would you prefer to read an e-book or a paperback?",
    choices: {
      A: "The bookstore has a large selection.",
      B: "The library closes at 8 p.m.",
      C: "Let me see which one is cheaper.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "전자책으로 읽으시겠습니까, 아니면 종이책으로 읽으시겠습니까?",
      choices: {
        A: "서점에 다양한 책이 구비되어 있습니다.",
        B: "도서관은 오후 8시에 문을 닫습니다.",
        C: "어느 쪽이 더 저렴한지 확인해보겠습니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. C는 가격 비교가 필요하다며 결정을 보류하는 적절한 답변입니다. A는 서점의 책 구비 현황에 대한 정보이고, B는 도서관 운영 시간에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 12,
    questionText: "Would you prefer short hair or long hair?",
    choices: {
      A: "The salon is fully booked today.",
      B: "I need to check some styles before deciding.",
      C: "The new shampoo smells great.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "짧은 머리와 긴 머리 중 어느 쪽을 선호하시나요?",
      choices: {
        A: "미용실이 오늘 예약이 다 찼습니다.",
        B: "스타일을 좀 더 확인해보고 결정하고 싶습니다.",
        C: "새로운 샴푸 향이 좋네요.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. B는 스타일 확인이 필요하다며 결정을 보류하는 적절한 답변입니다. A는 미용실 예약 상황에 대한 정보이고, C는 샴푸 향에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 13,
    questionText:
      "Should we schedule the meeting for Friday or over the weekend?",
    choices: {
      A: "The conference room is available.",
      B: "The new company policy was announced.",
      C: "I'd rather keep it on a weekday.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "회의를 금요일에 할까요, 아니면 주말에 할까요?",
      choices: {
        A: "회의실이 사용 가능합니다.",
        B: "새로운 회사 정책이 발표되었습니다.",
        C: "평일에 하는 것이 좋겠습니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. C는 평일을 선택하는 적절한 답변입니다. A는 회의실 사용 가능 여부에 대한 정보이고, B는 회사 정책 발표에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 14,
    questionText: "Should we complete this task individually or as a team?",
    choices: {
      A: "The deadline is next Wednesday.",
      B: "Let me check the workload first.",
      C: "The printer needs more paper.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "이 과제를 개별적으로 할까요, 아니면 팀으로 할까요?",
      choices: {
        A: "마감일이 다음 주 수요일입니다.",
        B: "업무량을 먼저 확인해보겠습니다.",
        C: "프린터에 종이를 더 넣어야 합니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. B는 업무량 확인이 필요하다며 결정을 보류하는 적절한 답변입니다. A는 마감일에 대한 정보이고, C는 프린터 용지에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 15,
    questionText:
      "Should we start the project now or wait for further approval?",
    choices: {
      A: "We should wait until we get confirmation.",
      B: "The project requires multiple teams.",
      C: "The cafeteria menu has changed.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "프로젝트를 지금 시작할까요, 아니면 추가 승인을 기다릴까요?",
      choices: {
        A: "확인을 받을 때까지 기다리는 게 좋겠습니다.",
        B: "이 프로젝트는 여러 팀이 필요합니다.",
        C: "구내식당 메뉴가 변경되었습니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. A는 승인을 기다리자는 적절한 답변입니다. B는 프로젝트 규모에 대한 정보이고, C는 구내식당 메뉴에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 16,
    questionText:
      "Is it better to finish the task in the morning or in the afternoon?",
    choices: {
      A: "The deadline is next Friday.",
      B: "The printer needs more ink.",
      C: "Either time works for me.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question:
        "오전에 업무를 끝내는 게 좋을까요, 아니면 오후에 끝내는 게 좋을까요?",
      choices: {
        A: "마감일이 다음 주 금요일입니다.",
        B: "프린터에 잉크를 더 넣어야 합니다.",
        C: "언제든 괜찮습니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. C는 두 시간대 모두 가능하다는 적절한 답변입니다. A는 마감일에 대한 정보이고, B는 프린터 잉크에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 17,
    questionText: "Would you rather have the meeting on Monday or Wednesday?",
    choices: {
      A: "That depends on the team's availability.",
      B: "We usually hold meetings in the morning.",
      C: "The agenda hasn't been finalized yet.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "월요일과 수요일 중 언제 회의를 하는 게 좋을까요?",
      choices: {
        A: "팀원들의 일정에 따라 결정하는 게 좋겠습니다.",
        B: "우리는 보통 아침에 회의를 합니다.",
        C: "회의 안건이 아직 확정되지 않았습니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. A는 팀원들의 일정 확인이 필요하다며 신중한 결정을 제안하는 적절한 답변입니다. B는 일반적인 회의 시간에 대한 정보이고, C는 회의 안건 준비 상태에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 18,
    questionText:
      "Would you prefer to receive the report via email or in print?",
    choices: {
      A: "I'd rather get a digital copy to save paper.",
      B: "The report is about our annual sales performance.",
      C: "I printed some documents this morning.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question:
        "보고서를 이메일로 받으시겠습니까, 아니면 출력물로 받으시겠습니까?",
      choices: {
        A: "종이를 절약하기 위해 디지털 사본으로 받고 싶습니다.",
        B: "이 보고서는 연간 매출 실적에 관한 것입니다.",
        C: "오늘 아침에 문서를 몇 장 출력했습니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. A는 디지털 사본을 선택하면서 환경 보호라는 이유도 함께 제시하는 적절한 답변입니다. B는 보고서 내용에 대한 정보이고, C는 개인적인 출력 경험에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 19,
    questionText: "Is working in a team or independently better?",
    choices: {
      A: "The team meeting is on Wednesday.",
      B: "It depends on the type of project.",
      C: "The IT department is hiring interns.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question:
        "팀으로 일하는 것과 개별적으로 일하는 것 중 어느 것이 더 좋을까요?",
      choices: {
        A: "팀 미팅이 수요일에 있습니다.",
        B: "프로젝트 유형에 따라 다릅니다.",
        C: "IT 부서에서 인턴을 채용 중입니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. B는 프로젝트 유형에 따라 달라진다며 신중한 고려를 보여주는 적절한 답변입니다. A는 팀 미팅 일정에 대한 정보이고, C는 인턴 채용에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
  {
    questionNumber: 20,
    questionText:
      "Do you want to attend the networking event or the year-end party?",
    choices: {
      A: "I'd rather skip both this year.",
      B: "The company organizes annual events.",
      C: "The IT help desk is on the second floor.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "네트워킹 이벤트와 연말 파티 중 어느 쪽에 참석하시겠습니까?",
      choices: {
        A: "올해는 둘 다 참석하지 않는 게 좋겠습니다.",
        B: "회사에서 매년 행사를 주최합니다.",
        C: "IT 헬프데스크는 2층에 있습니다.",
      },
    },
    explanation:
      "선택형 의문문에는 제시된 선택지 중 하나를 선택하여 답변해야 합니다. A는 제시된 두 선택지 모두를 거절하며 다른 선택을 제안하는 적절한 답변입니다. B는 회사 행사에 대한 일반적인 정보이고, C는 헬프데스크 위치에 대한 답변으로, 둘 다 선택과 무관합니다.",
  },
];
